import ExportedImage from 'next-image-export-optimizer';

import AnimateWhileInView from '@/components/shared/AnimateWhileInView';
import CtaButton from '@/components/shared/lp/CtaButton';

import { siteData } from '@/data/configs/site';
import decentralized from '@/public/images/lp/home/decentralized.png';
import protocolSupport from '@/public/images/lp/home/protocolSupport.png';

const ProtocolSupport = () => {
  return (
    <section className='mx-auto my-10 flex items-center justify-between gap-x-[82px] text-white lg:my-24 lg:w-full 2xl:my-36 -lg:flex-col'>
      <div className='flex w-1/2 flex-col space-y-4 md:w-1/2 -lg:mb-12 -lg:w-[80%] -lg:items-center -lg:text-center -sm:w-auto'>
        <AnimateWhileInView delay={0.1}>
          <h2 className='home-small-header font-sans text-xs font-normal uppercase sm:text-sm xl:text-base 2xl:text-lg'>
            Secure
          </h2>
        </AnimateWhileInView>
        <AnimateWhileInView delay={0.15}>
          <h3 className='font-heading text-3xl font-bold sm:text-4xl lg:text-3xl xl:text-5xl'>
            Fully Non-Custodial & Decentralized
          </h3>
        </AnimateWhileInView>
        <AnimateWhileInView delay={0.2}>
          <p className='text-xl -lg:text-lg'>
            Seed Phrases/Private Keys and all other sensitive data generated by the wallet is
            managed on your own device and never leaves it. You are always in full control. The DEX
            is fully decentralized with no middleman. Trade P2P using atomic swaps.
          </p>
        </AnimateWhileInView>
        <AnimateWhileInView delay={0.2}>
          <CtaButton href={siteData.webDEXlink} newtab='yes'>
            Get Started
          </CtaButton>
        </AnimateWhileInView>
      </div>
      <AnimateWhileInView
        delay={0.3}
        classNaming='relative flex w-full items-center justify-center pt-[60px] lg:w-1/2 lg:pt-0'
      >
        <div>
          <div
            className='absolute left-1/2 top-1/2 z-[-10] h-[377px] w-[377px] -translate-x-1/2 -translate-y-1/2'
            style={{
              borderRadius: '377px',
              opacity: 0.8,
              background: 'linear-gradient(90deg, #493DB5 0%, #6DABD4 100%)',
              mixBlendMode: 'plus-lighter',
              filter: 'blur(162.35000610351562px)',
              width: '377px',
              height: '377px',
            }}
          ></div>
          <ExportedImage
            placeholder='empty'
            className='h-auto w-[480px] 2xl:w-[510px]'
            src={decentralized}
            alt='Fully non-custodial & decentralized'
          />
        </div>
      </AnimateWhileInView>
    </section>
  );
};

export default ProtocolSupport;
